import { ifAuthenticated } from '@/libs/acl/routeProtection'
import useEnvString from '@/composables/useEnvString'
import {
    DASHBOARD,
    SUMMARY,
    COST_ALLOCATION_TAGS,
    CLOUD_FRONT,
    DATA_TRANSFER,
    ALL_CONSOLIDATED,
    COST_PIVOT,
    DYNAMIC_SEARCH,
    INVOICE,
    OPEN_API,
    BANK_ACCOUNT
} from '@/service'
export default [
    {
        path: '/dashboard',
        redirect: '/'
    },
    {
        path: '/',
        name: 'dashboard',
        component: () => import('@/views/Dashboard.vue'),
        meta: {
            selectType: 'group-project-month',
            headerType: 'dashboard',
            services: [DASHBOARD],
            serviceIdx: null
        },
        beforeEnter: ifAuthenticated
    },
    {
        path: '/summary',
        name: 'summary',
        component: () => import('@/views/Summary.vue'),
        meta: {
            selectType: 'project-month',
            headerType: 'summary',
            services: [SUMMARY],
            serviceIdx: null
        },
        beforeEnter: ifAuthenticated
    },
    {
        path: '/tags',
        name: 'tags',
        component: () => import('@/views/CostByTag.vue'),
        meta: {
            selectType: 'project-month',
            headerType: 'base',
            services: [COST_ALLOCATION_TAGS],
            serviceIdx: null,
            pageTitle: 'Cost by Tag',
            breadcrumb: [
                {
                    text: 'Cost by Tag',
                    active: true
                }
            ]
        },
        beforeEnter: ifAuthenticated
    },
    {
        path: '/cloudfront',
        name: 'cloudfront',
        component: () => import('@/views/CloudFront.vue'),
        meta: {
            selectType: 'project-month',
            headerType: 'base',
            services: [CLOUD_FRONT],
            serviceIdx: null,
            pageTitle: 'CloudFront',
            breadcrumb: [
                {
                    text: 'CloudFront',
                    active: true
                }
            ]
        },
        beforeEnter: ifAuthenticated
    },
    {
        path: '/data-transfers',
        name: 'data-transfers',
        component: () => import('@/views/DataTransfer.vue'),
        meta: {
            selectType: 'project-month',
            headerType: 'base',
            services: [DATA_TRANSFER],
            serviceIdx: null,
            pageTitle: 'Data Transfer',
            breadcrumb: [
                {
                    text: 'Data Transfer',
                    active: true
                }
            ]
        },
        beforeEnter: ifAuthenticated
    },
    {
        path: '/consolidated',
        name: 'consolidated',
        component: () => import('@/views/AllConsolidated.vue'),
        meta: {
            selectType: 'group-project-month',
            headerType: 'base',
            services: [ALL_CONSOLIDATED],
            serviceIdx: null,
            pageTitle: 'All Consolidated',
            breadcrumb: [
                {
                    text: 'All Consolidated',
                    active: true
                }
            ]
        },
        beforeEnter: ifAuthenticated
    },
    {
        path: '/consolidated/product',
        name: 'consolidatedProduct',
        component: () => import('@/views/AllConsolidatedProduct.vue'),
        meta: {
            selectType: 'month',
            services: [ALL_CONSOLIDATED],
            serviceIdx: null,
            navActiveLink: 'consolidated',
            pageTitle: 'All Consolidated Accounts by Products',
            breadcrumb: [
                {
                    text: 'All Consolidated',
                    active: true
                }
            ]
        },
        beforeEnter: ifAuthenticated
    },
    {
        path: '/pivot',
        name: 'pivot',
        component: () => import('@/views/CostPivot.vue'),
        meta: {
            headerType: 'base',
            services: [COST_PIVOT],
            serviceIdx: null,
            pageTitle: 'Cost Pivot',
            subAction: {
                component: 'AppBreadCrumbSubActionBadge',
                text: 'org.common.View in new window',
                handleClick: () => {
                    const { VUE_APP_BILLING_URL } = useEnvString()
                    var newWindow = window.open(`${VUE_APP_BILLING_URL}/pivot/new`, 'newwindow', 'width=' + screen.width + ', height=' + screen.height + ', location=no')
                    newWindow.moveTo(0, 0)
                    newWindow.resizeTo(screen.width, screen.height)
                }
            },
            breadcrumb: [
                {
                    text: 'Cost Pivot',
                    active: true
                }
            ]
        },
        beforeEnter: ifAuthenticated
    },
    {
        path: '/pivot/new',
        name: 'pivotNew',
        component: () => import('@/views/CostPivot.vue'),
        props: route => ({ code: route.query.layout }),
        meta: {
            layout: 'full',
            headerType: 'base',
            services: [COST_PIVOT],
            serviceIdx: null,
            pageTitle: 'Cost Pivot',
            breadcrumb: [
                {
                    text: 'Cost Pivot',
                    active: true
                }
            ]
        },
        beforeEnter: ifAuthenticated
    },
    {
        path: '/dynamic-search',
        name: 'dynamic-search',
        component: () => import('@/views/DynamicSearch.vue'),
        meta: {
            selectType: 'group-project',
            headerType: 'base',
            services: [DYNAMIC_SEARCH],
            serviceIdx: null,
            pageTitle: 'Dynamic Search',
            breadcrumb: [
                {
                    text: 'Dynamic Search',
                    active: true
                }
            ]
        },
        beforeEnter: ifAuthenticated
    },
    {
        path: '/invoices',
        name: 'invoices',
        component: () => import('@/views/Invoices.vue'),
        meta: {
            selectType: 'project-year',
            headerType: 'base',
            services: [INVOICE],
            serviceIdx: null,
            pageTitle: 'Invoices',
            breadcrumb: [
                {
                    text: 'Invoices',
                    active: true
                }
            ]
        },
        beforeEnter: ifAuthenticated
    },
    {
        path: '/open-api',
        name: 'open-api',
        component: () => import('@/views/OpenApi/OpenApi.vue'),
        meta: {
            services: [OPEN_API],
            serviceIdx: null,
            pageTitle: 'Open API',
            breadcrumb: [
                {
                    text: 'Open API',
                    active: true
                }
            ]
        },
        beforeEnter: ifAuthenticated
    },
    {
        path: '/user-guide',
        name: 'user-guide',
        component: () => import('@/views/UserGuide/Index.vue'),
        meta: {
            layout: 'full',
            resource: 'Auth',
            action: 'read'
        }
    },
    {
        path: '/bank-account',
        name: 'bank-account',
        component: () => import('@/views/BankAccount.vue'),
        meta: {
            services: [BANK_ACCOUNT],
            serviceIdx: null,
            pageTitle: 'Bank Account',
            breadcrumb: [
                {
                    text: 'Bank Account',
                    active: true
                }
            ]
        },
        beforeEnter: ifAuthenticated
    }
]
